import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const bitacoraService = {
  getBitacoraByIdPresupuesto,
}

async function getBitacoraByIdPresupuesto(id) {
  return await ApiBudgety.get('Bitacora/FindAllByIdPresupuesto/' + id, {
    headers: {
      ACCION: MenusSistema.presupuesto_listado.accesos.ver_bitacora,
      MENU: MenusSistema.presupuesto_listado.id,
    },
  })
}
